import React from 'react';

/* eslint-disable @atlaskit/design-system/ensure-design-token-usage, @atlaskit/design-system/no-custom-icons */
import Icon from '@atlaskit/icon/base';

type AnchorIconProps = {
	label: string;
};

export const AnchorIcon = ({ label = '' }: AnchorIconProps) => {
	const anchorSVG = () => (
		<svg
			viewBox="0 0 95 92"
			focusable="false"
			role="presentation"
			data-testid="test-to-satisfy-sonar"
		>
			{/* FIXME: Remove embedded image from svg */}
			{/* eslint-disable-next-line no-restricted-syntax */}
			<image
				x="22"
				y="17"
				width="48"
				height="55"
				href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAA3CAYAAABKB8k/AAABL0lEQVRoge2Z0Q7DIAhF3bL//2WWNFnStYAiILhxkyV70nsEFO2j+QiIUc3n8wCgzLvM+bQcLELWEeit/kdm87pGAACOn6e2T6GqgYt+qwZWqFII0dKDzKuVaAiIy1x/k0K+pxGtrr/ahaJV2+hFdRJLVTeyaBVAtAogWgUQrQKI1vYAr1VXP0N9+cUiEHX7GtHNG5VCGSFQT1wNZIIgvfSKOAME6yH7LtRdwOwA6meVDFsq62H7GjjTWdxlR4CtXgOPcSQ1YBWNkXGG5zoDWK2wVqIoYqZnH6ckcGbzarZRUEQELv+nI0ulTdaG7uaXy/tsEKjXXuFmgSB9Ztl5OLEet//EJOl1VkMMeZM2a6sghn3NdpteIGI/2nbZCmTah1W/PwuS/QlH1yZ01Vp7AwIZOEHBdISzAAAAAElFTkSuQmCC"
			/>
		</svg>
	);

	return <Icon label={label} size="medium" glyph={anchorSVG} />;
};
